import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import attachThemeAttrs from '../../../../styles/helpers/attachThemeAttrs';
var StyledFileCard = attachThemeAttrs(styled.div)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: solid 1px ", ";\n    background-color: ", ";\n    padding: 20px 8px 20px 16px;\n    display: flex;\n    margin: 0 16px 32px 16px;\n    border-radius: 12px;\n"])), function (props) {
  return props.palette.background.highlight;
}, function (props) {
  return props.palette.background.secondary;
});
export default StyledFileCard;